<template lang="html">
  <div id="results-page">

    <section class="mb-2 breadcrumb-section">
      <div class="container oversized-container">
        <span>Emprendedor</span>
        <span class="line">/</span>
        <span>{{ entrepreneur.brand }}</span>
      </div>
    </section>

    <section class="container oversized-container entrepreneur-section">
      <div class="row align-items-center">
        <div class="col-12 col-md-4 col-lg-3 col-logo">
          <img :src="entrepreneur.imageUrlLogo">
        </div>

        <div class="col-12 col-md-8 col-lg-9 col-info">
          <h2 class="title-s2">{{ entrepreneur.brand }}</h2>

          <div class="box-extra">
            <a class="t-150 btn-whatsapp" target="_blank" :href="'https://wa.me/'+entrepreneur.phone"><i class="fab fa-whatsapp icon"></i> Chatea con el vendedor</a>
          </div>
          <!-- <div class="box-rating">
            <b-form-rating inline no-border size="lg" variant="warning" readonly v-model="entrepreneur.rating" stars="5"></b-form-rating>
            <div class="rating-number">{{ entrepreneur.rating }}</div>
          </div> -->

          <div class="info" v-html="entrepreneur.comments"></div>
        </div>

        <!-- <div class="offset-md-4 offset-lg-3 mt-3 col-md-8 col-lg-9 col-rating-form">
          <b-form class="box-rating-form" @submit="addRating">
            <h5 class="subt">Califica este creador</h5>

            <div class="box-stars">
              <b-form-rating inline required v-model="stars" stars="5"></b-form-rating>
            </div>

            <div class="box-input">
              <p class="mt-1">
                <b-button type="submit" class="btn-co">Calificar</b-button>
              </p>
            </div>
          </b-form>
        </div> -->
      </div>
      <!-- Categorias -->
      <!-- <div class="row">
        <div class="col-lg">
          <div class="row">
            <div class="col-2" v-for="(cate, index) in categories" :key="index" style="text-align: center;">
              {{ cate.name }}
            </div>
          </div>
        </div>
      </div> -->

    </section>

    <section class="container oversized-container pt-2 mt-4 products-section">
      <div class="row">
        <!-- Results -->
        <div class="col-lg">
          <div class="row sample-products-wrapper xxl-4e">
            <div class="col-sm-6 col-lg-3 sample-product shad-prod" v-for="(product, index) in products" :key="index">
              <router-link class="outlined-box" :to="'/producto/'+$root._converToURL(product.name, product.id)">
                <div class="box-image">
                  <div v-if="product.disabled == true">
                    <div class="out-of-stock">No disponible</div>
                  </div>
                  <div v-else>
                    <div class="out-of-stock" v-if="product.stock < 1">Agotado</div>
                  </div>


                  <div class="placed-backg img" v-bind:style="{ backgroundImage: 'url('+product.img+')' }" style="background-size:contain !important;">
                    <img src="public/images/shared/product.png" >
                  </div>
                </div>

                <div class="box-shot-descr">
                  <h6 class="sku">{{ product.sku }}</h6>
                  <h6 class="name">{{ product.name }}</h6>
                  <h6 class="price" v-bind:class="{ 'discount' : product.activate_discount }" style="min-height: 51px;">
                        <!-- PRECIO TACHADO SIN DESCUENTO-->
                        <span class="cross" v-if="product.type_disc == 'descuento_envio' || product.type_disc == 'descuento'">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} </span>
                        <!-- PRECIO NORMAL-->
                        <span v-else-if="product.type_disc == null || product.type_disc == 'envio'">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format(product.price) }} </span>
                        <!-- PRECIO FINAL CON DESCUENTO-->
                        <span v-if="product.type_disc == 'descuento_envio' || product.type_disc == 'descuento'">$ {{ Intl.NumberFormat("en-US", { minimumFractionDigits: 2 }).format( product.price_discount) }}</span>
                        <!-- ENVIO GRATIS-->
                        <span class="free-shipping" v-if="product.type_disc == 'descuento_envio' || product.type_disc == 'envio'"><i class="fas fa-shipping-fast"></i> Envío gratis</span>
                    </h6>

                    <div v-if="product.disabled == true">
                      <h6 style="color: gray;">No disponible</h6>
                    </div>
                    <div v-else>

                        <h6 v-if="product.stock > 0" class="stock">{{ product.stock }} en stock</h6>
                        <h6 v-else style="color: gray;">Sin stock</h6>
                    </div>
                </div>
                <p class="p-button">
                  <a class="btn-more">Ver más</a>
                </p>
              </router-link>
            </div>

            <div class="col-12 text-center">
              <h5 v-if="!products.length" style="text-align:center;">Aun no tenemos productos en esta categoría. ¿ Tienes un emprendimiento relacionado a esto?  <router-link to="/asociarse"> ¡Regístra tu negocio ! </router-link></h5>
            </div>
          </div>

          <div class="row" v-if="pagination.total_products > 8">
                  <div class="col-12 text-center">
                    <div class="d-inline-block mx-0 col-pagination-sample-1">
                      <b-pagination-nav :link-gen="linkGen" :number-of-pages="pagination.total" use-router></b-pagination-nav>
                    </div>
                  </div>
                </div>

        </div>
        <!--  -->
        <sweet-modal ref="modalLoading" hide-close-button blocking width="20%">
          <modalLoadingComponent></modalLoadingComponent>
              <p style="font-weight: 600; color: #291063; font-size: 1.1rem;">Cargando, espere ...</p>
        </sweet-modal>

         <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block"  ref="modal">
        <div v-html="modal.msg"></div>
        <div class="col-12 text-center" style="padding-top: 20px;" v-if="modal.icon == 'success'">
            <b-button class="btn btn-primary" slot="button" v-on:click.prevent="$refs.modal.close()">Aceptar</b-button>

        </div>
    </sweet-modal>

      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{
      id:null,
      isLoading: true,

      products: [],
      entrepreneur: {
        name: '',
        id: 0,
        rating:0
      },
      pagination:{
        currentpage:1,
        total:1,
        number: 10,
        total_products:1,
      },
      stars:null,
      modal:{
        msg:'',
        icon:'',
        block:false
      },
      categories:[],


    }
  },

  methods: {
    getProducts: function(){
      this.isLoading = true;
      this.$refs.modalLoading.open();

      axios.get(tools.url('/api/productsentrepreneurs/'+this.id+"?page=" + this.pagination.currentpage)).then((response)=>{

        this.products = response.data.products.data;

        this.entrepreneur = response.data.entrepreneur;
        this.categories = response.data.categories;
        this.pagination.total = response.data.products.last_page;
        this.pagination.total_products = response.data.products.total;
        this.isLoading = false;
        this.$refs.modalLoading.close();
      }).catch((error)=>{
        console.log(error);
        this.$refs.modalLoading.close();
      })
    },
     linkGen(pageNum) {
      return pageNum === 1 ? '?' : `?page=${pageNum}`
    },
    addRating(evt){
      evt.preventDefault();
        var formdata = {
          users_id:this.id,
          stars:this.stars
        };
        axios.post(tools.url('/api/storeEntrepreneursRating'),formdata).then((response)=>{
          this.modal.icon = 'success';
          this.modal.msg = 'Gracias por tu calificacion';
          this.$refs.modal.open();
          this.getProducts();

        }).catch((error)=>{
          console.log(error);
          this.modal.icon = 'error';
          this.modal.msg = 'Error al guardar la calificacion';
          this.$refs.modal.open();
        })
    }

  },

  mounted(){
    if(this.$route.params.id){
        this.id= this.$root._getURLID(this.$route.params.id);
        this.getProducts();
    }
  },

  watch: {
    '$route.params.id':function(){
          this.id= this.$root._getURLID(this.$route.params.id);
          this.getProducts();
      },
      '$route.query.page':function(val){

      if (val) {
          this.pagination.currentpage = val;

      }
      else{
          this.pagination.currentpage = 1;
      }
        this.getProducts();
    },
  },
}
</script>
